import React, { Component } from "react";

import Menu from "./menu";

import "./css/gifshop.css";

import gifshopGifsJNEXCH8H8GIF from "./images/gifshop/gifs/JNEXCH8H8.gif";

import gifshopImportJPG from "./images/gifshop/import.jpg";
import gifshopImportMP4 from "./images/gifshop/import.mp4";

import gifshopCaptureJPG from "./images/gifshop/capture.jpg";
import gifshopCaptureMP4 from "./images/gifshop/capture.mp4";

import gifshopLibraryJPG from "./images/gifshop/library.jpg";
import gifshopLibraryMP4 from "./images/gifshop/library.mp4";

import gifshopShareLinkJPG from "./images/gifshop/share_link.jpg";
import gifshopShareLinkMP4 from "./images/gifshop/share_link.mp4";

import gifshopGifs1GIF from "./images/gifshop/gifs/1.gif";
import gifshopGifs2GIF from "./images/gifshop/gifs/2.gif";
import gifshopGifs3GIF from "./images/gifshop/gifs/3.gif";
import gifshopGifs4GIF from "./images/gifshop/gifs/4.gif";
import gifshopGifs5GIF from "./images/gifshop/gifs/5.gif";
import gifshopGifs6GIF from "./images/gifshop/gifs/6.gif";

class GIFSHOP extends Component {
  render() {
    return (
      <div className="gifshop-page">
        <Menu type="projects" />
        <div className="intro section-wrapper">
          <div className="section">
            <div className="logo">
              <div className="logo-image"></div>
              <p className="logo-tagline">The animated .gif maker for your iPhone</p>
            </div>
          </div>
          <div className="examples">
            <img src={gifshopGifs1GIF} alt="" className="gif-1" />
            <img src={gifshopGifs2GIF} alt="" className="gif-2" />
            <img src={gifshopGifs3GIF} alt="" className="gif-3" />
            <img src={gifshopGifs4GIF} alt="" className="gif-4" />
            <img src={gifshopGifs5GIF} alt="" className="gif-5" />
            <img src={gifshopGifs6GIF} alt="" className="gif-6" />
          </div>
        </div>
        <div className="section-wrapper has-divider">
          <div className="section context">
            <div className="column">
              <h2>Context</h2>
              <p>
                Remember 2010? Before auto play videos decorated every social media feed, before Vine, before Giphy put
                a gif search engine in all your messaging apps, Instagram was on v1, Tumblr was so hot within creative
                communities that they couldn't keep their servers up and Apple was still in love with skeuomorphism.
              </p>
              <h2>Introduction</h2>
              <p>
                Hungry for a new challenge,{" "}
                <a href="http://somethingsavage.com" target="_blank" rel="noopener noreferrer">
                  Dan
                </a>{" "}
                and I decided to build an iOS app. This was the year photo apps took off so the idea of a stop motion
                .gif camera came by naturally to two animation nerds. We named it{" "}
                <a href="http://gifshop.tv" target="_blank" rel="noopener noreferrer">
                  GIF SHOP
                </a>
                .
              </p>
              <p>
                The screencaps below are from v2 which we launched a year later after the iPhone 5 introduced the taller
                screen.
              </p>
            </div>
          </div>
        </div>
        <div className="section-wrapper has-divider">
          <div className="section slide">
            <div className="flex-column">
              <div className="copy">
                <h2>A toy is a tool</h2>
                <p>
                  The very first prototype felt so playful it took me by surprise. There was something special about
                  touching the screen and seeing the ghost of the moment frozen in the onion skin. The gratification of
                  the instant playback. The original instinct was to design a stark utilitarian UI in spirit of the
                  familiar design tooling - however after some time with the prototype the direction turned a lot more
                  playful. A toy is a tool of learning.
                </p>
              </div>
            </div>
            <div className="fixed-column">
              <div className="phone">
                <video autoPlay loop muted playsInline preload="auto" poster={gifshopCaptureJPG}>
                  <source src={gifshopCaptureMP4} type="video/mp4" />
                  Your browser doesn't support HTML5 video tag.
                </video>
              </div>
            </div>
          </div>
        </div>
        <div className="section-wrapper has-divider">
          <div className="section slide">
            <div className="flex-column">
              <div className="copy">
                <h2>Creative expression</h2>
                <p>
                  Not the first nor the last .gif maker on iOS. I would argue what made it special from the start is the
                  simple fact that the app encouraged creative exploration. We made the decision to optimize for play
                  and creative expression over making it as fast as possible to capture and share a moment or to achieve
                  a specific formulaic result. This in some ways sealed its faith as a utility. Having seen the
                  alternative played out in other products over the years I am still personally happy with this
                  decision.
                </p>
              </div>
            </div>
            <div className="fixed-column">
              <div className="phone">
                <video autoPlay loop muted playsInline preload="auto" poster={gifshopImportJPG}>
                  <source src={gifshopImportMP4} type="video/mp4" />
                  Your browser doesn't support HTML5 video tag.
                </video>
              </div>
            </div>
          </div>
        </div>
        <div className="section-wrapper has-divider">
          <div className="section slide">
            <div className="flex-column">
              <div className="copy">
                <h2>Manage expectations</h2>
                <p>
                  In v2 we introduced 'Staff picks' which was a curated list of our favorite animations. The intention
                  was to highlight all the creative work and the people behind them in order to build a community around
                  the app. The feedback was immediate and negative from one large segment: parents. The app was
                  initially purposefully designed to be respectful of privacy and we kept parental concerns in mind. The
                  change was not in line with the expectations we had set and parents were understandably not happy. We
                  promptly removed the feature until we could build in parental controls that would communicate the
                  change appropriately.
                </p>
              </div>
            </div>
            <div className="fixed-column">
              <div className="phone">
                <video autoPlay loop muted playsInline preload="auto" poster={gifshopLibraryJPG}>
                  <source src={gifshopLibraryMP4} type="video/mp4" />
                  Your browser doesn't support HTML5 video tag.
                </video>
              </div>
            </div>
          </div>
        </div>
        <div className="section-wrapper has-divider">
          <div className="section">
            <div className="column">
              <h2>500 KB</h2>
              <p>
                500 KB was the .gif file size limit Tumblr would host and trying to upload a larger file would convert
                the animation to a static .jpg with no warning. This was the best case scenario as all other social
                platforms were outright hostile toward animated .gifs at the time. In this context it became necessary
                to offer a file hosting service and integrate with every social platform to make sharing as seamless as
                possible.
              </p>
            </div>
            <div className="feature-image">
              <video autoPlay loop muted playsInline preload="auto" poster={gifshopShareLinkJPG}>
                <source src={gifshopShareLinkMP4} type="video/mp4" />
                Your browser doesn't support HTML5 video tag.
              </video>
            </div>
          </div>
        </div>
        <div className="section-wrapper has-divider conclusion">
          <div className="section">
            <div className="column">
              <h2>Looking ahead</h2>
              <p>
                GIF SHOP was featured numerous times on the App Store, voted Wired Magazine Editor’s Pick, FWA Mobile
                app of the day, Gizmodo app of the day and{" "}
                <a href="http://www.swiss-miss.com/2011/07/gif-shop.html" target="_blank" rel="noopener noreferrer">
                  more
                </a>
                .
              </p>
              <p>
                I learned a lot about what I find meaningful in a project. I learned code rot is a real thing on
                platforms we have no control over that change every year with disregard for backward compatibility.
                Above all I learned running a service is a big responsibility.
              </p>
              <p>
                What strikes me as most valuable about the project are the creative artifacts left behind. Out of
                respect for those, shared animation links remained operational until June 1st, 2023, and all account
                holders received a link to download a complete archive of their data. In July 2025 I announced a{" "}
                <a href="https://gifshop.tv" target="_blank" rel="noopener noreferrer">
                  faithful re-creation of GIF SHOP as a cross platform web-app
                </a>
                .
              </p>
              <p>Thanks for all the .gifs!</p>
              <br />
              <br />
              <p>
                <img src={gifshopGifsJNEXCH8H8GIF} alt="" />
              </p>
            </div>
            <div className="column">
              <p>
                <a href="#top" className="to-top">
                  Back to top
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GIFSHOP;



// WEBPACK FOOTER //
// ./src/gifshop.js